import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
var FlowOptionLoading = function FlowOptionLoading(_ref) {
  var _ref$length = _ref.length,
    length = _ref$length === void 0 ? 24 : _ref$length,
    className = _ref.className,
    gridClassName = _ref.gridClassName;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex flex-col gap-3 md:grid md:grid-cols-6 md:gap-8", gridClassName)
  }, Array.from({
    length: length
  }).map(function (_, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: twMerge("h-12 bg-gray-200 rounded-lg animate-pulse md:h-[106px]", className)
    });
  })));
};
export default FlowOptionLoading;